<template>
    <div>
        <v-server-table ref="InjuryTypeTable" url="/admin/injury-types-list" :columns="columns" :options="options">

            <router-link slot="InjuryTypeId" slot-scope="props" :to="`/incidents/settings/injury-types/edit/${props.row.InjuryTypeId}`" title="Edit Nature of Injury" class="btn btn-sm btn-secondary">
                Edit
            </router-link>

            <template slot="IsActive" slot-scope="props">
                <label :class="`text-${props.row.IsActive == 1 ? 'success' : 'danger'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['InjuryTypeId', 'TypeName', 'IsActive'],
                options: {
                    headings: {
                        IncidentTypeId: 'Edit',
                        TypeName: 'Nature of Injury',
                        IsActive: 'Status',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'injurytype.TypeName',
                    },
                    uniqueKey: 'InjuryTypeId',
                },
            }
        }
    }
</script>
